//TODO: add removal of subitems on clicking of parent item

<template>
  <div>
    <v-layout column ma-3>
      <span
        class="black--text mr-3 mb-3"
        v-if="tagCheck.length > 0 && tag_names.length > 0"
      >
        <span v-for="tn in tag_names" :key="tn" class="white mr-3"
          >#{{ tn }}</span
        >
      </span>

      <!-- @click:clear="search = ''" -->
      <!-- clearable -->
      <v-text-field
        name="search"
        label="Search"
        id="search"
        v-model="search"
        color="white"
      ></v-text-field>
      <h4 class="white--text font-weight-thin mb-1">
        Concept Tags {{ conceptualSectionCheck.length }} of {{ conceptual_tags.length }} selected
      </h4>
      <v-flex
        v-for="(ts, index) in conceptual_tag_categories"
        :key="ts.id"
        row
        v-if="conceptual_tag_categories.length > 0"
      >
        <p-check
          :name="`checkSection$index`"
          :value="ts.name"
          color="white"
          v-model="conceptualSectionCheck"
        >
          <label color="white" slot="default"> {{ ts.name }}</label>
        </p-check>
        <v-flex
          ml-3
          v-for="tc in conceptual_tags.filter(c => c.subcategory === ts.name)"
          :key="tc['id']"
          row
          v-if="conceptual_tags.length > 0"
        >
          <div v-if="conceptualSectionCheck.includes(tc['subcategory'])">
            <p-check
              :name="`check$index`"
              :value="tc.id"
              color="white"
              v-model="tagCheck"
            >
              <label color="white" slot="default"
                ><span class="mx-0 px-0" v-if="tc.concept_tag == 1"
                  >&starf;</span
                >
                {{ tc['name'] }} </label
                >
                <!-- {{ tc['name'] }} {{ tc['subcategory'] }}</label -->
            </p-check>
            <v-flex
              ml-5
              v-for="(tag, tagindex) in getTags(tc.subcategory)"
              :key="`t${tag.id}`"
            >
              <div v-if="check.includes(tag.subcategory)">
                <p-check
                  :name="`tagCheck$tagindex`"
                  :value="tag.id"
                  color="white"
                  v-model="tagCheck"
                >
                  <label slot="default">{{ tag.name }}</label>
                </p-check>
              </div>
            </v-flex>
          </div>
        </v-flex>
      </v-flex>

      <!-- <h4 class="white--text font-weight-thin">Keyword tags</h4> -->

      <h4 class="white--text font-weight-thin mt-3 mb-1">
        Cataloguing tags {{ sectionCheck.length }} of {{ cataloguing_tags.length }} selected
      </h4>
      <v-flex
        v-for="(ts, index) in $store.getters.cataloguing_tag_subcategories"
        :key="index"
        row
        v-if="$store.getters.cataloguing_tag_subcategories.length > 0"
      >
        <p-check
          :name="`checkSection$index`"
          :value="ts.subcategory"
          color="white"
          v-model="sectionCheck"
        >
          <label color="white" slot="default">{{ ts.subcategory == '' ? 'NO SUBCATEGORY' : ts.subcategory }}</label>
        </p-check>
        <v-flex
          ml-3
          v-for="(tag, tagindex) in getSubcategoryTags(ts.subcategory)"
          :key="`t${tag.id}`"
        >
          <div v-if="sectionCheck.includes(tag.subcategory)">
            <p-check
              :name="`tagCheck$tagindex`"
              :value="tag.id"
              color="white"
              v-model="tagCheck"
            >
              <label slot="default">{{ tag.name }}</label>
            </p-check>
          </div>
        </v-flex>
      </v-flex>
      <h4 class="white--text font-weight-thin mt-3 mb-1">Relation tags</h4>
      <v-flex
        v-for="(ts, index) in $store.getters.tag_sections_relation"
        :key="`rt$index`"
        row
        v-if="$store.getters.tag_sections_relation.length > 0"
      >
        <p-check
          :name="`checkSection$index`"
          :value="ts"
          color="white"
          v-model="sectionCheck"
        >
          <label color="white" slot="default">{{ ts }}</label>
        </p-check>
        <v-flex
          ml-0
          v-for="tc in $store.getters.tag_categories.filter(
            c => c.section === ts
          )"
          :key="tc['category']"
          row
          v-if="$store.getters.tag_categories.length > 0"
        >
          <div v-if="sectionCheck.includes(tc['section'])" class="ml-4">
            <p-check
              :name="`check$index`"
              :value="tc['category']"
              color="white"
              v-model="check"
            >
              <label color="white" slot="default">{{ tc['category'] }}</label>
            </p-check>
            <v-flex
              ml-3
              v-for="(tag, tagindex) in getTags(tc.category)"
              :key="`t${tag.id}`"
            >
              <div v-if="check.includes(tag.category)">
                <p-check
                  :name="`tagCheck$tagindex`"
                  :value="tag.id"
                  color="white"
                  v-model="tagCheck"
                >
                  <label slot="default">{{ tag.name }}::{{ tag.field_value }}</label>
                </p-check>
              </div>
            </v-flex>
          </div>
        </v-flex>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
export default {
  data() {
    return {
      search: '',
      check: [],
      tagCheck: [],
      conceptualSectionCheck: [],
      sectionCheck: []
    }
  },
  watch: {
    tagCheck(val) {
      // console.log(val)
      this.$emit('updateFilterTags', val)
    }
  },
  props: ['artwork'],
  computed: {
    conceptual_tag_categories() {
      if (this.search && this.search[0] == '#') {
        console.log(this.search)
        const s = this.search.substring(1)
        return this.$store.getters.conceptual_tag_categories.filter(ctg =>
          ctg.name.match(s)
        )
      } else {
        return this.$store.getters.conceptual_tag_categories
      }
    },
    conceptual_tags() {
      if (this.search && this.search.length > 2) {
        var foundTags = this.$store.getters.conceptual_tags.filter(ct =>
          ct.name.match(this.search)
        )
        // var conceptualToTurnOn = []
        this.conceptualSectionCheck = []
        foundTags.forEach(ft => {
          var cc = this.$store.getters.conceptual_tags.find(
            ct => ct.name == ft.category && ct.concept_tag == 1
          )
          if (cc) {
            this.conceptualSectionCheck.indexOf(cc.name) === -1
              ? this.conceptualSectionCheck.push(cc.name)
              : console.log('This item already exists')
          }
        })
      } else {
        var foundTags = this.conceptualSectionCheck
        foundTags.forEach(ft => {
          var cc = this.$store.getters.conceptual_tags.find(
            ct => ct.name == ft.category && ct.concept_tag == 1
          )
          if (cc) {
            this.conceptualSectionCheck.indexOf(cc.name) === -1
              ? this.conceptualSectionCheck.push(cc.name)
              : console.log('This item already exists')
          }
        })
      }
      // console.log(conceptualToTurnOn)
      // console.log(this.search)
      return this.$store.getters.conceptual_tags.filter(ct =>
        ct.name.match(this.search)
      )
    },
    cataloguing_tags() {
      return this.$store.getters.cataloguing_tags
    },
    tag_names() {
      return this.tagCheck.map(
        id => this.$store.state.tags.find(st => id == st.id).name
      )
    }
    // tag_categories () {
    //     var array = Object.assign([],this.$store.state.tags)
    //     console.log(array.length)
    //     var unique = [];
    //     var distinct = [];
    //     for( let i = 0; i < array.length; i++ ){
    //         if( !unique[array[i].category]){
    //             if (array[i].category != null) {
    //                 distinct.push(array[i].category);
    //                 unique[array[i].category] = 1;
    //             }
    //         }
    //     }
    //     return distinct.sort()
    // }
  },
  methods: {
    getTags(tc) {
      return this.$store.state.tags
        .filter(t => t.category == tc)
        .sort((a, b) => (a.name < b.name ? -1 : 0))
    },
    getSubcategoryTags(tc) {
      return this.$store.state.tags
        .filter(t => t.subcategory == tc)
        .sort((a, b) => (a.name < b.name ? -1 : 0))
    }
  }
}
</script>

<style lang="css" scoped>
.pretty .state label {
  text-indent: 1em;
}
label {
  color: white;
}
</style>



// WEBPACK FOOTER //
// src/components/artworks/TagFilter.vue